import { Box, Fab, styled } from '@mui/material';

export const ButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

export const DrawerEditButton = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(2),
  marginBlock: 'auto',
  zIndex: 100,
  '& svg': {
    marginRight: theme.spacing(1),
  },
}));

export const DrawerHeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.grey[900],
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(1),
}));
